import classNames from 'classnames'
import { useEffect, useState } from 'react'
import ImageWithBasePath from './ImageWithBasePath'

export const Disclosure = ({
  id,
  title = '',
  titleClassNmae = 'font-bold leading-[21.07px] text-base text-[#3B3A40]',
  containerClassName = 'border-t-[1px]',
  children,
  childrenClassName = '',
  titleImagePath = '',
  imageDetails = { width: 16, height: 16 },
  imageClassName = 'ml-[5.33px]',
  isDefaultOpen = false,
  widthOfDownArrow = 20,
  heightOfDownArrow = 20,
  onClick = () => {},
  isSelected = false,
  applicantInfo = false,
  selectedJob
}) => {
  const [isOpen, setOpen] = useState(isDefaultOpen || false)

  const clickHandler = () => {
    setOpen((prv) => !prv)
    onClick()
  }

  useEffect(() => {
    setOpen(isSelected)
  }, [isSelected])

  return (
    <div
      className={classNames(
        'flex h-auto w-full cursor-pointer flex-col border-[0px] border-solid border-xLigthGray py-sm',
        containerClassName
      )}
      {...{ id }}
    >
      <div
        className={classNames('flex items-center justify-between', titleClassNmae)}
        onClick={clickHandler}
      >
        <div className="flex items-center">
          {title}
          {titleImagePath?.length > 0 && (
            <ImageWithBasePath
              src={titleImagePath}
              width={imageDetails?.width}
              height={imageDetails?.height}
              className={imageClassName}
              alt={title}
            />
          )}
        </div>
        {!!children && (
          <div
            className={classNames(
              'flex items-center transition-all duration-300',
              isOpen && '-rotate-180 transform'
            )}
          >
            <ImageWithBasePath
              src="downArrow"
              width={widthOfDownArrow}
              height={heightOfDownArrow}
              alt="down arrow symbol"
            />
          </div>
        )}
      </div>
      {applicantInfo ? (
        <div className="flex h-[66px] w-[328px]  rounded-[12px] border-[1px] border-solid border-[#E5E5E5] px-[12px]">
          <div className="flex  flex-col space-y-[4px] border-[1px] border-l-[0px] border-t-[0px] border-b-[0px] border-r-[1px] border-solid border-[#E5E5E5] pr-[4px]">
            <div className="w-[153px] pt-[12px] font-noto-sans text-[12px] font-normal leading-[16px] text-[#666]">
              Views
            </div>
            <div className="w-[153px] pb-[12px] font-noto-sans text-[16px] font-bold leading-[24px] text-[#191919]">
              {selectedJob?.post?.views}
            </div>
          </div>

          <div className="flex flex-col  space-y-[4px] pl-[11px]">
            <div className="w-[136px] pt-[12px] font-noto-sans text-[12px] font-normal leading-[16px] text-[#666]">
              Total Applicants
            </div>
            <div className="w-[136px] pb-[12px] font-noto-sans text-[16px] font-bold leading-[24px] text-[#191919]">
              {selectedJob?.num_applications || 0}
            </div>
          </div>
        </div>
      ) : null}
      {isOpen && (
        <div className={classNames('animate-h_increase', childrenClassName)}>{children}</div>
      )}
    </div>
  )
}
